// Lightweight, dependency-free Markdown renderer for the legal documents.
// Supports: #/##/### headings, paragraphs, - / * bullet lists, 1. ordered
// lists, horizontal rules, inline **bold**, _italic_/*italic*, and [links](url).

function inline(text, kp) {
  const nodes = [];
  const re =
    /(\*\*([^*]+)\*\*)|(__([^_]+)__)|(\*([^*]+)\*)|(_([^_]+)_)|(\[([^\]]+)\]\(([^)]+)\))/g;
  let last = 0;
  let m;
  let k = 0;
  while ((m = re.exec(text))) {
    if (m.index > last) nodes.push(text.slice(last, m.index));
    if (m[1]) nodes.push(<strong key={`${kp}-b${k++}`}>{m[2]}</strong>);
    else if (m[3]) nodes.push(<strong key={`${kp}-b${k++}`}>{m[4]}</strong>);
    else if (m[5]) nodes.push(<em key={`${kp}-i${k++}`}>{m[6]}</em>);
    else if (m[7]) nodes.push(<em key={`${kp}-i${k++}`}>{m[8]}</em>);
    else if (m[9])
      nodes.push(
        <a
          key={`${kp}-a${k++}`}
          href={m[11]}
          target="_blank"
          rel="noopener noreferrer"
          className="underline text-[#4A6B41] hover:text-[#2F4829]"
        >
          {m[10]}
        </a>
      );
    last = re.lastIndex;
  }
  if (last < text.length) nodes.push(text.slice(last));
  return nodes;
}

const isSpecial = (l) =>
  /^(#{1,3}\s+|(-|\*)\s+|\d+\.\s+|(---|\*\*\*|___)\s*$)/.test(l);

export function Markdown({ text }) {
  const lines = (text || "").replace(/\r/g, "").split("\n");
  const blocks = [];
  let i = 0;
  let key = 0;

  while (i < lines.length) {
    const line = lines[i];
    if (/^\s*$/.test(line)) { i++; continue; }

    if (/^###\s+/.test(line)) {
      blocks.push(<h3 key={key++} className="mt-7 mb-2 font-sans font-bold text-lg text-[#1C241B]">{inline(line.replace(/^###\s+/, ""), key)}</h3>);
      i++; continue;
    }
    if (/^##\s+/.test(line)) {
      blocks.push(<h2 key={key++} className="mt-9 mb-3 font-sans font-extrabold text-2xl text-[#1C241B]">{inline(line.replace(/^##\s+/, ""), key)}</h2>);
      i++; continue;
    }
    if (/^#\s+/.test(line)) {
      blocks.push(<h1 key={key++} className="mt-6 mb-4 font-sans font-extrabold text-3xl text-[#1C241B]">{inline(line.replace(/^#\s+/, ""), key)}</h1>);
      i++; continue;
    }
    if (/^(---|\*\*\*|___)\s*$/.test(line)) {
      blocks.push(<hr key={key++} className="my-8 border-[#D8E0D5]" />);
      i++; continue;
    }
    if (/^(-|\*)\s+/.test(line)) {
      const items = [];
      while (i < lines.length && /^(-|\*)\s+/.test(lines[i])) {
        items.push(lines[i].replace(/^(-|\*)\s+/, "")); i++;
      }
      blocks.push(
        <ul key={key++} className="my-4 pl-6 list-disc space-y-1.5 text-[#2b332a]">
          {items.map((it, idx) => <li key={idx}>{inline(it, `${key}-${idx}`)}</li>)}
        </ul>
      );
      continue;
    }
    if (/^\d+\.\s+/.test(line)) {
      const items = [];
      while (i < lines.length && /^\d+\.\s+/.test(lines[i])) {
        items.push(lines[i].replace(/^\d+\.\s+/, "")); i++;
      }
      blocks.push(
        <ol key={key++} className="my-4 pl-6 list-decimal space-y-1.5 text-[#2b332a]">
          {items.map((it, idx) => <li key={idx}>{inline(it, `${key}-${idx}`)}</li>)}
        </ol>
      );
      continue;
    }
    // paragraph
    const para = [];
    while (i < lines.length && !/^\s*$/.test(lines[i]) && !isSpecial(lines[i])) {
      para.push(lines[i]); i++;
    }
    blocks.push(
      <p key={key++} className="my-4 text-[#2b332a] leading-relaxed">
        {inline(para.join(" "), key)}
      </p>
    );
  }

  return <>{blocks}</>;
}
